import { ProductVariantValue } from './product-variants'

export const isNotAvailableForSale = (productVariantValue: ProductVariantValue) => {
  return !productVariantValue?.product?.availability?.isAvailableForSale
}

export const hasNoValidVariantCombinations = (productVariantValue: ProductVariantValue) => {
  const noVariantCombinationExist = !productVariantValue?.productVariantCombinationExists

  return noVariantCombinationExist
}
